import { createSelector } from '@ngrx/store';
import { selectJobseekerStoreState } from '../jobseeker-profile/selectors';
import { selectChildSpecializations, selectHeadSpecializations, selectSpecializationsMap } from '../jobseeker-specialization/selectors';
import { selectSystemConfigs } from '../../selectors';

export const selectSpecializationPickerState = createSelector(
    selectJobseekerStoreState,
    s => s.specializationPicker,
);


export const selectSelectedSpecializationIds = createSelector(
  selectSpecializationPickerState,
    s => s.selectedSpecializationIds
)

export const selectMaxSpecializationsReached = createSelector(
  selectSelectedSpecializationIds,
  selectSystemConfigs,
   (s, c) => s.length >= c.jobseeker.workExperienceMaxSpecializations
);



export const selectSelectedSpecializations = createSelector(
  selectSelectedSpecializationIds,
    selectSpecializationsMap,
    (s, c) => s.map(cc => c[cc])
);



export const selectHeadSpecializationsExpandedMap = createSelector(
    selectHeadSpecializations,
    selectSpecializationPickerState,
    (headSpecializations, uiState) => {
      const result: { [index: string]: boolean } = {};
  
      headSpecializations.forEach((c) => {
        result[c.specializationId] = false;
      });
  
      uiState.expandedSpecializationIds.forEach((c) => {
        result[c] = true;
      });
  
      return result;
    }
  );
  
  export const selectSpecializationsSelectedMap = createSelector(
    selectSpecializationPickerState,
    selectChildSpecializations,
    (f, o) => {
      const result = {};
      o.forEach((c) => (result[c.specializationId] = false));
      f.selectedSpecializationIds.forEach((c) => (result[c] = true));

      return result;
    }
  );


export const selectDisplaySelectedSpecializationsTags = createSelector(
    selectSelectedSpecializations,
    s => s.concat().sort((a, b) => a.name.localeCompare(b.name))
);


export const selectQuery = createSelector(
  selectSpecializationPickerState,
    s => s.query
);

export const selectDisplayHeadSpecializations = createSelector(
    selectQuery,
    selectHeadSpecializations,
    selectChildSpecializations,
    (query, headSpecializations, childSpecializations) => {

        const matchedHeads = headSpecializations.filter(c => checkQuery(c.name, query));
        const matchedHeadIdSet = new Set(matchedHeads.map(c => c.specializationId));
        
        const remainingMatchingChildren = childSpecializations.filter(c => checkQuery(c.name, query) && !matchedHeadIdSet.has(c?.head.specializationId));

        const remainingMatchingChildrenHeadIdSet = new Set(remainingMatchingChildren.map(c => c.head.specializationId));
        const remainingMatchingChildrenIdSet = new Set(remainingMatchingChildren.map(c => c.specializationId));

        const remainingMatchigHeads = headSpecializations.filter(c => remainingMatchingChildrenHeadIdSet.has(c.specializationId)).map(c => {
            const result = Object.assign({}, c, { childSpecializationIds: c.childSpecializationIds.filter(cc => remainingMatchingChildrenIdSet.has(cc)) });

            return result;
        });
        
        return matchedHeads.concat(remainingMatchigHeads).sort((a, b) => a.name > b.name ? 1 : (a.name < b.name ? -1 : 0));
    }
);

export const selectDisplayHeadSpecializationsSorted = createSelector(
  selectDisplayHeadSpecializations,
  selectSpecializationsMap,
  (selectHead, selectAllSpecializationsMap) => {
    const selectedHead = selectHead.map((v) => {
      return {
        ...v,
        childSpecializationIds: v.childSpecializationIds
          .map((vv) => selectAllSpecializationsMap[vv])
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((specializations) => specializations.specializationId),
      };
    });
    
    return selectedHead;
  }
);


function checkQuery(text: string, query: string){
    return query === null || query ==='' || query.length < 2 || text.includes(query);
}


export const selectAtLeastOneSpecializationSelected = createSelector(
    selectSelectedSpecializationIds,
    s => s.length > 0
);